export function getHash(): string | null {
  return window.location.hash.substring(1) || null;
}

export function setHash(hash: string) {
  window.location.hash = hash;
}

export function removeHash() {
  history.pushState('', document.title, window.location.pathname + window.location.search);
}
